import React from "react";

class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorMessage: "",
      errorStack: "",
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      errorMessage: error?.message || "Unknown error",
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error("RouteErrorBoundary caught an error:", error, errorInfo);

    this.setState({
      errorStack: errorInfo?.componentStack || "",
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            background: "#050505",
            color: "#ffffff",
            padding: "24px",
            fontFamily: "Inter, sans-serif",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              maxWidth: "1100px",
              margin: "0 auto",
              background: "#0b0b0b",
              border: "1px solid rgba(212, 175, 55, 0.18)",
              borderRadius: "18px",
              padding: "24px",
            }}
          >
            <h1
              style={{
                margin: "0 0 12px",
                fontSize: "28px",
                color: "#d4af37",
              }}
            >
              Debug Error Captured
            </h1>

            <p
              style={{
                margin: "0 0 18px",
                color: "#d0d0d0",
                lineHeight: "1.6",
              }}
            >
              Page blank honey ki bajaye actual error yahan show ho raha hai.
            </p>

            <div
              style={{
                marginBottom: "18px",
                padding: "14px",
                borderRadius: "12px",
                background: "#111111",
                border: "1px solid rgba(255,255,255,0.08)",
              }}
            >
              <div
                style={{
                  fontSize: "13px",
                  color: "#c9b06d",
                  marginBottom: "8px",
                }}
              >
                Error Message
              </div>
              <pre
                style={{
                  margin: 0,
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  color: "#ff8a80",
                  fontSize: "14px",
                }}
              >
                {this.state.errorMessage}
              </pre>
            </div>

            <div
              style={{
                marginBottom: "18px",
                padding: "14px",
                borderRadius: "12px",
                background: "#111111",
                border: "1px solid rgba(255,255,255,0.08)",
              }}
            >
              <div
                style={{
                  fontSize: "13px",
                  color: "#c9b06d",
                  marginBottom: "8px",
                }}
              >
                Component Stack
              </div>
              <pre
                style={{
                  margin: 0,
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  color: "#e7e7e7",
                  fontSize: "13px",
                }}
              >
                {this.state.errorStack || "No stack available"}
              </pre>
            </div>

            <button
              type="button"
              onClick={this.handleReload}
              style={{
                background: "linear-gradient(135deg, #d4af37, #f5d76e)",
                color: "#111111",
                border: "none",
                borderRadius: "12px",
                padding: "12px 18px",
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default RouteErrorBoundary;